import React from "react"
import LogoSvg from "../../../static/images/logo-gendo.svg"
import LogoDark from "../../../static/images/logo-gendo-dark.svg"

import * as S from "./styled"

const Logo = props => (
  <S.LogoImage
    {...props}
    src={props.small ? LogoDark : LogoSvg}
    alt="Gendo Blog"
    title="Gendo Blog"
  />
)

export default Logo
